// 资产卡片组件
export default {
  // 标题
  totalAssetBalance: "总资产余额",

  // 提示信息
  balanceDescription:
    "地址总资产余额是根据本系统已收录的币种价值，按地址持有的所有主币和代币折算USDT的总余额",
  systemSupport: "系统当前已支持",
  currencyCount: "317个币种",

  // 单位
  usdtUnit: "USDT",
};
